export default __webpack_public_path__ + "static/media/Think5Whys Sample Certificate.1a025be1ed415a42c731183162d00625.png";